(function () {
	this.AdventuresService = function (plugin) {
		this.plugin = plugin;
		this.loadingInProgress = false;
		this.adventuresListings = [];

		const galleryLoadButton = document.querySelector( '.js-fya-adventures-listing.current .js-fya-adventures-listing-load-more-button' );

		if( galleryLoadButton ) {
			this.LoadMoreAdventures( galleryLoadButton, true );
		}

		this.loadMoreClickHandler = function (event, element) {
			event.preventDefault();

			this.LoadMoreAdventures(element);
		}.bind(this);
	};

	this.AdventuresService.prototype.RegisterLoadMoreClickListeners = function () {
		var adventuresListings = document.querySelectorAll(
			this.plugin.Config.selectors.adventures.listing.base
		);

		if (!adventuresListings) {
			return;
		}

		for (var buttonIndex = 0; buttonIndex < adventuresListings.length; buttonIndex++) {
			var button = adventuresListings[buttonIndex].querySelector(
				this.plugin.Config.selectors.adventures.listing.buttonLoadMore
			);
			if (button) {
				this.RegisterLoadMoreClickListener(button);
			}
		}
	};

	this.AdventuresService.prototype.LoadVotesListing = function () {
		const voteButtons = document.querySelectorAll('.js-fya-vote-item-button');
		
		if (voteButtons.length === 0) {
			this.plugin.Logger.Debug('No vote buttons found');
			return;
		}

		// Gather all data-id values
		const ids = Array.from(voteButtons).map(button => {
			const id = button.getAttribute('data-id');
			return id ? parseInt(id, 10) : null;
		}).filter(id => id !== null);

		if (ids.length === 0) {
			this.plugin.Logger.Debug('No valid IDs found');
			return;
		}

		this.plugin.Logger.Debug('Fetching votes for IDs', ids);

		// Send request to custom endpoint
		fetch(`${this.plugin.Config.apiUrl}/votes-listing`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ ids: ids })
		})
		.then(response => response.json())
		.then(data => {
			if (data.votes) {
				// Update each vote display
				voteButtons.forEach(button => {
					const id = button.getAttribute('data-id');
					if (id && data.votes[id] !== undefined) {
						button.setAttribute( 'data-votes', data.votes[id] );

						const votesElement = button.parentElement.querySelector('.js-fya-vote-item-votes');
						if (votesElement) {
							votesElement.textContent = data.votes[id];
						}
					}
				});
				this.plugin.Logger.Debug('Votes updated successfully');
			}
		})
		.catch(error => {
			this.plugin.Logger.Log('Error loading votes', error);
		});
	};

	this.AdventuresService.prototype.RegisterLoadMoreClickListener = function (element) {
		const parentListing = element.closest(
			this.plugin.Config.selectors.adventures.listing.base
		);

		if (!parentListing) {
			this.plugin.Logger.Log('Element does not have a parent listing', element);
			return;
		}

		const limit = parentListing.getAttribute('data-limit');

		if (!limit) {
			this.plugin.Logger.Log('Element does not has data limit', element);
			return;
		}

		var found = false;
		for (
			var adventuresListIndex = 0;
			adventuresListIndex < this.adventuresListings.length;
			adventuresListIndex++
		) {
			var adventuresList = this.adventuresListings[adventuresListIndex];
			if (element === adventuresList) {
				this.plugin.UnbindClick(element);
				found = true;
				break;
			}
		}

		if (found === false) {
			this.adventuresListings.push(element);
		}

		this.plugin.BindClick(element, this.loadMoreClickHandler);
	};

	this.AdventuresService.prototype.LoadMoreAdventures = function (element, firstLoad = false) {
		if (this.loadingInProgress) {
			this.plugin.Logger.Debug('Loading is already in progress, skipping');
			return;
		}

		this.loadingInProgress = true;

		const adventuresListing = element.closest(this.plugin.Config.selectors.adventures.listing.base);
		const limit = parseInt(adventuresListing.getAttribute('data-limit'), 10);
		const currentRound = parseInt(adventuresListing.getAttribute('data-current-round') || -1, 10);
		const offset = adventuresListing.querySelectorAll('li').length;
		const pageId = parseInt(adventuresListing.getAttribute('data-page-id') || 0, 10);

		this.plugin.Logger.Debug('Loading more adventures', { limit, offset });

		fetch(`${this.plugin.Config.apiUrl}/list?limit=${limit}&offset=${offset}&round=${currentRound}&pageid=${pageId}`)
			.then(response => response.json())
			.then(data => {
				if (data.adventures && data.adventures.length > 0) {
					data.adventures.forEach(adventure => {
						const ul = adventuresListing.querySelector('ul');
						if (ul) {
							ul.insertAdjacentHTML('beforeend', adventure);
						}
					});

					//Register like button events
					this.plugin.Voter.RegisterVoteButtonClickListeners();
					this.FindYourAdventure.Adventures.LoadVotesListing();

					if (data.adventures.length === limit) {
						return;
					}
				}

				// Hide the button if no more adventures
				this.plugin.Logger.Debug('No more adventures to load');
				element.style.display = 'none';
			})
			.catch(error => {
				this.plugin.Logger.Log('Error loading adventures', error);
			})
			.finally(() => {
				this.loadingInProgress = false;
			});
	};
}).bind(window.FindYourAdventure)();
